<template>
  <wtFormRight>
    <!-- -TOOLBARS -->
    <template slot="toolbars">
      <Toolbars
        :objProps="objItem"
        :objPropsData="objItemData"
        :urlServices="urlServices"
        :primary_key="primary_key"
        :nameObjData="nameObjData"
        :requiredEndDt="requiredEndDt"
        :noDelete="noDelete"
      />
    </template>

    <!-- VIEW TABLE -->
    <template slot="table" v-if="showGrid">
      <BpmProcessTaskGrid @selectedBpmProcessTask="objRowSelected = $event"></BpmProcessTaskGrid>
    </template>

    <!-- VIEW FORM -->
    <template slot="form" v-if="!showGrid">
      <b-form class="text-uppercase">
        <div class="form-row" v-if="!objItem.bpm_task_id">
          <div class="form-group col-md-6">
            <label for="bpm_process_version_id">Process Version ID</label>
            <input
              type="text"
              class="form-control"
              id="bpm_process_version_id"
              v-model.trim="objItemData.bpm_process_version_id"
              readonly
            />
          </div>
        </div>
        <hr class="mb-4" />
        <div class="form-row">
          <div class="form-group col-md-4">
            <label for="bpm_task_task_name">Task Name</label>
            <input
              type="text"
              class="form-control"
              id="bpm_task_task_name"
              v-model.trim="objItemData.task_name"
              @keyup="verifyVersion"
            />
          </div>
          <div class="form-group col-md-4">
            <label for="bpm_task_task_label">Task Label</label>
            <input
              type="text"
              class="form-control"
              id="bpm_task_task_label"
              v-model.trim="objItemData.task_label"
            />
          </div>

          <!----------------------------------->
          <div class="form-group col-md-6">
            <label for="resource_resource_name">Open schedule id</label>
            <SchedulerFind
              @schedulerFind="schedulerFind=$event"
              :getScheduler="schedulerFind"
              :urlOrigem="urlServices"
            ></SchedulerFind>
          </div>
          <!----------------------------------->
          <div class="form-group col-md-6">
            <label for="resource_resource_name">Close Queue Id</label>
            <QueueFind @queueFind="queueFind=$event" :getQueue="queueFind" :urlOrigem="urlServices"></QueueFind>
          </div>
          <!----------------------------------->

          <div class="form-group col-md-4 col-xl-3">
            <label for="bpm_task_open_function_name">Open Function Name</label>
            <input
              type="text"
              class="form-control"
              id="bpm_task_open_function_name"
              @keyup="objItemData.open_function_name = functionSanitization(objItemData.open_function_name)"
              v-model.trim="objItemData.open_function_name"
            />
          </div>
          <div class="form-group col-md-4 col-xl-3">
            <label for="bpm_task_close_function_name">Close Function Name</label>
            <input
              type="text"
              class="form-control"
              id="bpm_task_close_function_name"
              @keyup="objItemData.close_function_name = functionSanitization(objItemData.close_function_name)"
              v-model.trim="objItemData.close_function_name"
            />
          </div>
          <div class="form-group col-md-4 col-xl-3">
            <label for="bpm_task_attach_doc_types">Attach Doc Types</label>
            <input
              type="text"
              class="form-control"
              id="bpm_task_attach_doc_types"
              v-model.trim="objItemData.attach_doc_types"
            />
          </div>
          <input
            type="hidden"
            class="form-control"
            id="bpm_task_role_id_alloweds"
            v-model.trim="objItemData.role_id_alloweds"
          />
        </div>
        <!-- PREDECESSORS -->
        <hr class="mb-4" />
        <div class="form-row">
          <div class="form-group col-md-12">
            <label>Tasks Predecessors</label>
          </div>
          <div class="form-group col-md-5">
            <select
              name="task_predecessor_list"
              size="6"
              class="wt-select-card"
              v-model="selectedTask"
            >
              <option
                v-for="task in sortTask()"
                :key="task.task_id"
                :value="task.task_id"
              >{{task.task_label}}</option>
              <option v-if="isEmpty(taskList)" disabled>...</option>
            </select>
          </div>
          <div class="form-group col-md-2">
            <b-button
              variant="primary"
              @click="addNewTask(selectedTask)"
              style="width: 100%"
              class="mb-1 task-pre-btn"
            >
              Add
              <span v-show="!responsive">
                <i class="fas fa-arrow-right arrow-task arrow-right"></i>
              </span>
              <span v-show="responsive">
                <i class="fas fa-arrow-down arrow-task arrow-right"></i>
              </span>
            </b-button>
            <b-button
              variant="primary"
              @click="removeATask"
              style="width: 100%"
              class="mb-1 task-pre-btn"
            >
              <span v-show="!responsive">
                <i class="fas fa-arrow-left arrow-task arrow-left"></i>
              </span>
              <span v-show="responsive">
                <i class="fas fa-arrow-up arrow-task arrow-left"></i>
              </span> Remove
            </b-button>
            <b-button
              variant="primary"
              @click="removeAllTasks"
              style="width: 100%"
              class="task-pre-btn"
            >
              <span v-show="!responsive">
                <i class="fas fa-arrow-left arrow-task arrow-left"></i>
              </span>
              <span v-show="responsive">
                <i class="fas fa-arrow-up arrow-task arrow-left"></i>
              </span> Remove All
            </b-button>
          </div>
          <div class="form-group col-md-5">
            <select
              name="selected_predecessor_list"
              size="6"
              class="wt-select-card"
              v-model="selectedTaskRemove"
            >
              <option
                v-for="task in taskListSelected"
                :key="task.task_id"
                :value="task.task_id"
              >{{task.task_label}}</option>
              <option v-if="isEmpty(taskListSelected)" disabled>...</option>
            </select>
          </div>
        </div>
        <SecurityRoleSelect
          :base_id="objItem.bpm_task_id"
          :role_list="objItemData.role_id_alloweds"
          @roleIdList="updateRole"
        ></SecurityRoleSelect>
        <pre style="text-transform: lowercase">{{objItem}}</pre>
      </b-form>
    </template>
  </wtFormRight>
</template>
<script>
/** RECURSOS DO VUE **/
import { baseApiUrl, baseApiPort } from "@/global";
import axios from "axios";

/* COMPONENTS - LAYOUT */
import wtFormRight from "@/components/forms/wtFormRight";
import Toolbars from "@/components/widgets/Toolbars";

import QueueFind from "@/modules/streamline_ds/internal/queue/QueueFind";
import SchedulerFind from "@/modules/streamline_ds/internal/scheduler/SchedulerFind";
import SecurityRoleSelect from "@/modules/security_ds/internal/security_role/SecurityRoleSelect";

/* COMPONENTS - PAGE */
import BpmProcessTaskGrid from "./BpmProcessTaskGrid";

export default {
  name: "BpmProcessTask",

  /* COMPONENTS IN USE */
  components: {
    wtFormRight,
    Toolbars,
    BpmProcessTaskGrid,
    QueueFind,
    SchedulerFind,
    SecurityRoleSelect
  },

  /* COMPUTED VARIABLES */
  computed: {
    showGrid() {
      return this.$store.state.layout.showGrid;
    },
    urlServicesStore() {
      return this.$store.state.urlServicesStore;
    },
    objShared() {
      return this.$store.state.objShared;
    },
    objSelected() {
      return this.$store.state.objSelected;
    },
    objProcess() {
      return this.$store.state.objProcess;
    },
    action() {
      return this.$store.state.action;
    },
    mq() {
      return this.$mq;
    }
  },

  /* VARIABLES */
  data: function() {
    return {
      /* Controls */
      urlServices: "chameleon-ds/api/internal/bpm-task",
      primary_key: "bpm_task_id",

      /* Objects Page */
      objItem: {},
      objItemData: {},
      objRowSelected: {},
      nameObjData: "bpm_task_data",
      requiredEndDt: false,
      noDelete: true,
      responsive: false,

      /* Others Query */
      regexTaskTest: true,

      schedulerFind: {},
      queueFind: {},
      taskList: [],
      taskListSelected: [],
      selectedTask: "",
      selectedTaskRemove: ""
    };
  },

  /* METHODS */
  methods: {
    load(objItem) {
      this.$store.commit("setShowLoading", true);
      this.$store.commit("setShowGrid", false);

      const param = {};
      param[`${this.primary_key}`] = objItem[`${this.primary_key}`];
      const url = `${baseApiUrl}:${baseApiPort}/${this.urlServices}/find/`;

      axios.post(url, param).then(res => {
        this.objItem = res.data[0];
        this.objItemData = this.objItem[`${this.nameObjData}`];
        this.getQueue();
        this.getSchedule();
        this.$store.commit("setShowLoading", false);
        this.getObjItemDataList();
      });
    },
    /**
     * GET METHODS - Preenche campos que já devem ser carregados juntos ao formulário
     * Alguns são ativados somente quando há o load de um item para edição
     * mas a lista de tasks sempre é carregada por completa independendo da situação
     */
    getQueue() {
      const queue = {};
      queue.queue_id = this.objItemData.close_queue_id;

      const url = `${baseApiUrl}:${baseApiPort}/streamline-ds/api/internal/queue/find`;
      axios.post(url, queue).then(res => {
        this.queueFind = res.data[0];
      });
    },
    getSchedule() {
      const scheduler = {};
      scheduler.scheduler_id = this.objItemData.open_schedule_id;

      const url = `${baseApiUrl}:${baseApiPort}/streamline-ds/api/internal/scheduler/find`;
      axios.post(url, scheduler).then(res => {
        this.schedulerFind = res.data[0];
      });
    },
    getTaskList() {
      this.clearTaskList();
      let paramFilter = {};
      let id = this.objProcess.version_data
        ? this.objProcess.version_data.bpm_process_version_id
        : this.objProcess.bpm_process_version_id;
      let tempTaskList = {};

      const url = `${baseApiUrl}:${baseApiPort}/${this.urlServices}/find-all-by-bpm-process-version-id`;
      paramFilter = { bpm_process_version_id: id };
      axios.post(url, paramFilter).then(res => {
        if (res.data[0][`${this.primary_key}`] != null) tempTaskList = res.data;
        tempTaskList.forEach(e => {
          this.taskList.push({
            task_id: e.bpm_task_id,
            task_label: e.bpm_task_data.task_label
          });
        });
      });
    },
    getObjItemDataList() {
      if (!this.isEmpty(this.objItemData)) {
        if (!this.isEmpty(this.objItemData.task_id_predecessors)) {
          let toArray = this.stringToArray(
            this.objItemData.task_id_predecessors
          );
          this.$nextTick(() => {
            toArray.forEach(e => {
              this.addNewTask(e[0]);
            });
          });
        }
      }
    },
    /**
     * TASKS SELECT BOX - Controla a entrada e saída
     * de tasks predecessoras da lista, incluindo o
     * posicionamento em ordem alfabética e conversão
     * JSON>ARRAY e ARRAY>JSON
     */
    clearTaskList() {
      this.taskList = [];
      this.taskListSelected = [];
      this.selectedTask = "";
      this.selectedTaskRemove = "";
    },
    sortTask() {
      return this.taskList.slice().sort(function(a, b) {
        return a.task_label > b.task_label ? 1 : -1;
      });
    },
    addNewTask(filt) {
      if (filt) {
        var objFiltered = this.taskList.filter(function(elem) {
          if (elem.task_id == filt) return elem;
        });
        if (!this.isEmpty(objFiltered)) {
          this.taskListSelected.push(objFiltered[0]);
          this.taskList.splice(
            this.taskList.findIndex(r => r.task_id === filt),
            1
          );
          this.selectedTask = "";
          this.updateObjItemDataList();
        }
      }
    },
    removeATask() {
      if (this.selectedTaskRemove) {
        const filt = this.selectedTaskRemove;
        var objFiltered = this.taskListSelected.filter(function(elem) {
          if (elem.task_id == filt) return elem;
        });
        this.taskList.push(objFiltered[0]);
        this.taskListSelected.splice(
          this.taskListSelected.findIndex(r => r.task_id === filt),
          1
        );
        this.selectedTaskRemove = "";
        this.updateObjItemDataList();
      }
    },
    removeAllTasks() {
      this.taskListSelected.forEach(e => this.taskList.push(e));
      this.taskListSelected = [];
      this.updateObjItemDataList();
    },
    updateObjItemDataList() {
      let splitList = [];
      this.objItemData.task_id_predecessors = null;
      if (!this.isEmpty(this.taskListSelected)) {
        this.taskListSelected.forEach(e => {
          splitList.push(e.task_id);
        });
        this.objItemData.task_id_predecessors = splitList.join(",");
      }
    },
    /**
     * GENERAL FUNCTIONS
     * Funções de uso geral
     */
    isEmpty(obj) {
      for (let x in obj) {
        return false;
      }
      return true;
    },
    getSizewindow() {
      if (this.mq == "sm" || this.mq == "xs") {
        this.responsive = true;
      } else {
        this.responsive = false;
      }
    },
    updateRole(payload) {
      this.objItemData.role_id_alloweds = payload;
    },
    stringToArray(input) {
      if (!Array.isArray(input)) {
        var adapt = String(input).replace("[", "");
        adapt = adapt.replace("]", "");
        adapt = adapt.replace(/'/g, "");
        adapt = adapt.replace(/"/g, "");
        adapt = adapt.split(",");
        return adapt;
      } else {
        return input;
      }
    },
    functionSanitization(input) {
      var adapt = String(input).replace(/[^A-Za-z\d_()]+/g, "");
      return adapt;
    },
    verifyVersion() {
      const verify = /^([0-9]+)\.([0-9]+)\.([0-9]+)$/;
      this.regexVersionTest = verify.test(this.objItemData.version_number);
    }
  },

  /* WATCH */
  watch: {
    objRowSelected() {
      this.load(this.objRowSelected);
      this.$store.commit("setAction", "modify");
    },
    /* pay attention, this watcher has been changed */
    action() {
      if (this.urlServicesStore === this.urlServices) {
        if (this.action === "reset") {
          this.objItem = {};
          this.objItemData = {};
        }
      }
    },
    schedulerFind() {
      this.objItemData.open_schedule_id = this.schedulerFind.scheduler_id;
    },
    queueFind() {
      this.objItemData.close_queue_id = this.queueFind.queue_id;
    },
    mq() {
      this.getSizewindow();
    },
    showGrid() {
      if (this.showGrid) {
        this.objItem = {};
        this.objItemData = {};
      } else {
        /* set process id to version */
        if (this.objProcess)
          if (this.objProcess.version_data) {
            this.objItemData.bpm_process_version_id = this.objProcess.version_data.bpm_process_version_id;
            this.getTaskList();
            this.getSizewindow();
          }
      }
    }
  },
  mounted() {}
};
</script>